//include 1
//******************************************
// browser test

/**
 * description: the default class for the overlay for all sites is "hide".
 * if we have ie we add the class is-ie-lt-11 which overrides the hide class
 * and shows the overlay.
 * if the user decides to close the overlay we add the class "show-site".
 * we do this because we still want to keep the ie11 class (in case we want to use it somewhere else).
 */

var ua = window.navigator.userAgent;
var msie = ua.indexOf('MSIE ');
var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
if (msie > 0) { // || isIE11) {
    document.body.classList.add("is-ie-lt-11");
}

function removeIncompatibleBrowserOverlay() {
    document.body.classList.add("show-site");
}
//******************************************

//first thing to do is disabling google analytics if necessary
if (document.cookie.indexOf(disableStr + '=true') > -1) {
    window[disableStr] = true;
}

window.pixelpoint = window.pixelpoint || {};
window.pixelpoint.ppComponents = window.pixelpoint.ppComponents || {};
window.pixelpoint.promises = window.pixelpoint.promises || {};
window.pixelpoint.settings = window.pixelpoint.settings || {};
$(document).foundation();
moment.locale('de');
